import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const insertTeamReply = (content, channelType) => {
  const text = String(content || '').trim();
  if (!text) return false;

  const event = [INBOX_TYPES.WEB, INBOX_TYPES.EMAIL].includes(channelType)
    ? BUS_EVENTS.INSERT_INTO_RICH_EDITOR
    : BUS_EVENTS.INSERT_INTO_NORMAL_EDITOR;
  emitter.emit(event, text);
  return true;
};
